import { Component, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { environment } from '@env/environment';
import { ICurrency } from '@shared/models/currency.model';
import { CurrencyService } from '@shared/services/currency.service';
import { SessionStorageService } from '@shared/services/session-storage.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private _authService = inject(AuthService);
  private _sessionStorageService = inject(SessionStorageService);
  private title = inject(Title);

  ngOnInit(): void {
    let projectName = environment.projectName;

    if (projectName == 'cg') {
      this.title.setTitle('Coinigo My');
    } else {
      this.title.setTitle('Coinijet My');
    }

    this._sessionStorageService.getConfig();

    this._authService.getLoginSessionAndCheckToken();
    const html = document.getElementsByTagName('body')[0];
    let config = this._sessionStorageService.config;
    let theme = config.theme ?? (html.getAttribute('data-theme') as 'light' | 'dark') ?? 'light';
    this.toggleTheme(theme);
  }

  toggleTheme(theme: any) {
    const html = document.getElementsByTagName('body')[0];
    html.setAttribute('data-theme', theme);
  }
}
